import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { IAppState } from '@myStore/app.state';
import { GetActiveCoursesRequest } from '@myStore/courses-view/courses-view.actions';
import {
  AddContractCredentialsFailure,
  AddContractCredentialsRequest,
  AddContractCredentialsSuccess,
  AddDiscountFailure,
  AddDiscountForLeadFailure,
  AddDiscountForLeadRequest,
  AddDiscountForLeadSuccess,
  AddDiscountForStudentFailure,
  AddDiscountForStudentRequest,
  AddDiscountForStudentSuccess,
  AddDiscountRequest,
  AddDiscountSuccess,
  AddEnrolleeByHandFailure,
  AddEnrolleeByHandRequest,
  AddEnrolleeByHandSuccess,
  AddFileToTaskFailure,
  AddFileToTaskRequest,
  AddFileToTaskSuccess,
  AddLeadByHandFailure,
  AddLeadByHandRequest,
  AddLeadByHandSuccess,
  AddLeadDocumentsFailure,
  AddLeadDocumentsRequest,
  AddLeadDocumentsSuccess,
  AddPaymentNoteFailure,
  AddPaymentNoteRequest,
  AddPaymentNoteSuccess,
  ChangeEnrollDataInPresentationFailure,
  ChangeEnrollDataInPresentationRequest,
  ChangeEnrollDataInPresentationSuccess,
  ChangeLeadDataFailure,
  ChangeLeadDataRequest,
  ChangeLeadDataSuccess,
  ChangePresentationInfoFailure,
  ChangePresentationInfoRequest,
  ChangePresentationInfoSuccess,
  ChangeSalesTaskStatusFailure,
  ChangeSalesTaskStatusRequest,
  ChangeSalesTaskStatusSuccess,
  ChangeTaskExecuterFailure,
  ChangeTaskExecuterRequest,
  ChangeTaskExecuterSuccess,
  CloseDealToLeadFailure,
  CloseDealToLeadRequest,
  CloseDealToLeadSuccess,
  ConvertEnrolleeToLeadFailure,
  ConvertEnrolleeToLeadRequest,
  ConvertEnrolleeToLeadSuccess,
  CreateDealToLeadFailure,
  CreateDealToLeadRequest,
  CreateDealToLeadSuccess,
  CreateTaskForSalesFailure,
  CreateTaskForSalesRequest,
  CreateTaskForSalesSuccess,
  DeleteDealRequest,
  DeleteDiscountLeadRequest,
  DeleteDiscountStudentRequest,
  DeleteEnrolleeFailure,
  DeleteEnrolleeRequest,
  DeleteEnrolleeSuccess,
  DeleteFileFromTaskFailure,
  DeleteFileFromTaskRequest,
  DeleteFileFromTaskSuccess,
  DeleteLeadDocumentsFailure,
  DeleteLeadDocumentsRequest,
  EditContractCredentialsFailure,
  EditContractCredentialsRequest,
  EditContractCredentialsSuccess,
  EditDealFailure,
  EditDealRequest,
  EditDealSuccess,
  EditDiscountFailure,
  EditDiscountRequest,
  EditDiscountSuccess,
  EditEnrolleeFailure,
  EditEnrolleeRequest,
  EditEnrolleeSuccess,
  ESalesChangesActions,
  GenerateContractToLeadFailure,
  GenerateContractToLeadRequest,
  GenerateContractToLeadSuccess,
  GetAccessToEditLeadDataFailure,
  GetAccessToEditLeadDataRequest,
  GetAccessToEditLeadDataSuccess,
  IndicateLeadToCourseAndGroupFailure,
  IndicateLeadToCourseAndGroupRequest,
  IndicateLeadToCourseAndGroupSuccess,
  MakeCourseRecruitmentFailure,
  MakeCourseRecruitmentRequest,
  MakeCourseRecruitmentSuccess,
  SendPresentationApplicationFailure,
  SendPresentationApplicationRequest,
  SendPresentationApplicationSuccess,
  UpdateTaskDeadLineFailure,
  UpdateTaskDeadLineRequest,
  UpdateTaskDeadLineSuccess,
  UpdateTaskForSalesFailure,
  UpdateTaskForSalesRequest,
  UpdateTaskForSalesSuccess,
} from '@myStore/sales-changes/sales-changes.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { SalesChangesService } from '@services/sales-changes/sales-changes.service';
import { ToastrService } from 'ngx-toastr';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable()
export class SalesChangesEffects {
  constructor(
    private _actions$: Actions,
    private _store: Store<IAppState>,
    private _router: Router,
    private _toastr: ToastrService,
    private _salesChangesService: SalesChangesService
  ) {}

  getAccessToChangeLeadData$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetAccessToEditLeadDataRequest>(
          ESalesChangesActions.GetAccessToEditLeadDataRequest
        ),
        switchMap(action => {
          return this._salesChangesService
            .getAccessToEditLeadData(action.data)
            .pipe(
              map(() => {
                this._store.dispatch(new GetAccessToEditLeadDataSuccess());
              }),
              catchError(err => {
                this._toastr.error('Что-то пошло не так', '', {
                  timeOut: 3500,
                });
                this._store.dispatch(
                  new GetAccessToEditLeadDataFailure(err.error)
                );
                return err;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  $sendPresentationApplication$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<SendPresentationApplicationRequest>(
          ESalesChangesActions.SendPresentationApplicationRequest
        ),
        switchMap(action => {
          return this._salesChangesService
            .sendPresentationApplication(action.data)
            .pipe(
              map(() => {
                this._toastr.success('Абитуриент был успешно создан', '', {
                  timeOut: 3500,
                });
                this._store.dispatch(new SendPresentationApplicationSuccess());
              }),
              catchError(err => {
                this._toastr.error('Заявка не была отправлена', '', {
                  timeOut: 3500,
                });
                this._store.dispatch(
                  new SendPresentationApplicationFailure(err.error)
                );
                return err;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  $addLeadByHand$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<AddLeadByHandRequest>(ESalesChangesActions.AddLeadByHandRequest),
        switchMap(action => {
          return this._salesChangesService.sendAddLeadByHand(action.data).pipe(
            map(() => {
              this._toastr.success('Абитуриент был успешно создан', '', {
                timeOut: 3500,
              });
              this._store.dispatch(new AddLeadByHandSuccess());
            }),
            catchError(err => {
              this._toastr.error('Заявка не была отправлена', '', {
                timeOut: 3500,
              });
              this._store.dispatch(new AddLeadByHandFailure(err.error));
              return err;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  $addEnrolleeByHand$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<AddEnrolleeByHandRequest>(
          ESalesChangesActions.AddEnrolleeByHandRequest
        ),
        switchMap(action => {
          return this._salesChangesService
            .sendAddEnrolleeByHand(action.data)
            .pipe(
              map(() => {
                this._toastr.success('Заявка была успешно создана', '', {
                  timeOut: 3500,
                });
                this._store.dispatch(new AddEnrolleeByHandSuccess());
              }),
              catchError(err => {
                this._toastr.error('Заявка не была отправлена', '', {
                  timeOut: 3500,
                });
                this._store.dispatch(new AddEnrolleeByHandFailure(err.error));
                return err;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  $deleteEnrollee$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<DeleteEnrolleeRequest>(
          ESalesChangesActions.DeleteEnrolleeRequest
        ),
        switchMap(action => {
          return this._salesChangesService.deleteEnrollee(action.id).pipe(
            map(() => {
              this._toastr.success('Заявка была успешно перенеса в архив', '', {
                timeOut: 3500,
              });
              this._store.dispatch(new DeleteEnrolleeSuccess());
            }),
            catchError(err => {
              this._toastr.error('Заявка не была удалена', '', {
                timeOut: 3500,
              });
              this._store.dispatch(new DeleteEnrolleeFailure(err.error));
              return err;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  $deleteDeal$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<DeleteDealRequest>(ESalesChangesActions.DeleteDealRequest),
        switchMap(action => {
          return this._salesChangesService.deleteDeal(action.id).pipe(
            map(() => {
              this._toastr.success('Сделка была успешно перенеса в архив', '', {
                timeOut: 3500,
              });
              this._store.dispatch(new DeleteEnrolleeSuccess());
            }),
            catchError(err => {
              this._toastr.error(
                'Сделка не была удалена. Что-то пошло не так',
                '',
                {
                  timeOut: 3500,
                }
              );
              this._store.dispatch(new DeleteEnrolleeFailure(err.error));
              return err;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  makeCourseRecruitment$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<MakeCourseRecruitmentRequest>(
          ESalesChangesActions.MakeCourseRecruitmentRequest
        ),
        switchMap(action => {
          return this._salesChangesService
            .changeCourseRecruitment(action.data, action.id)
            .pipe(
              map(() => {
                this._store.dispatch(new MakeCourseRecruitmentSuccess());
                this._store.dispatch(new GetActiveCoursesRequest());
              }),
              catchError(err => {
                this._toastr.error('Что-то пошло не так', '', {
                  timeOut: 3500,
                });
                this._store.dispatch(
                  new MakeCourseRecruitmentFailure(err.error)
                );
                return err;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  changePresentationInfo$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<ChangePresentationInfoRequest>(
          ESalesChangesActions.ChangePresentationInfoRequest
        ),
        switchMap(action => {
          return this._salesChangesService
            .changePresentationInfo(action.data)
            .pipe(
              map(() => {
                this._store.dispatch(new ChangePresentationInfoSuccess());
                this._toastr.success('Информация успешно обновлена', '', {
                  timeOut: 3500,
                });
              }),
              catchError(err => {
                this._toastr.error('Что-то пошло не так', '', {
                  timeOut: 3500,
                });
                this._store.dispatch(
                  new ChangePresentationInfoFailure(err.error)
                );
                return err;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  changeLeadData$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<ChangeLeadDataRequest>(
          ESalesChangesActions.ChangeLeadDataRequest
        ),
        switchMap(action => {
          return this._salesChangesService
            .changeLeadData(action.data, action.id, action?.options)
            .pipe(
              map(() => {
                this._store.dispatch(new ChangeLeadDataSuccess());
                this._toastr.success('Данные лида успешно обновлены', '', {
                  timeOut: 3500,
                });
              }),
              catchError(err => {
                if (err.error.detail) {
                  this._toastr.error(err.error.detail, '', {
                    timeOut: 3500,
                  });
                } else {
                  this._toastr.error('Что-то пошло не так', '', {
                    timeOut: 3500,
                  });
                }
                this._store.dispatch(new ChangeLeadDataFailure(err.error));
                return err;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  convertEnrolleeToLead$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<ConvertEnrolleeToLeadRequest>(
          ESalesChangesActions.ConvertEnrolleeToLeadRequest
        ),
        switchMap(action => {
          return this._salesChangesService
            .convertEnrolleeToLead(action.data, action.id)
            .pipe(
              map(() => {
                this._store.dispatch(new ConvertEnrolleeToLeadSuccess());
                this._toastr.success(
                  'Заявка успешно конвертированна в лида',
                  '',
                  {
                    timeOut: 3500,
                  }
                );
              }),
              catchError(err => {
                if (err.error.detail) {
                  this._toastr.error(err.error.detail, '', {
                    timeOut: 3500,
                  });
                } else {
                  this._toastr.error('Что-то пошло не так', '', {
                    timeOut: 3500,
                  });
                }
                this._store.dispatch(
                  new ConvertEnrolleeToLeadFailure(err.error)
                );
                return err;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  createTask$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<CreateTaskForSalesRequest>(
          ESalesChangesActions.CreateTaskForSalesRequest
        ),
        switchMap(action => {
          return this._salesChangesService
            .createTask(action?.lead_id, action?.taskData)
            .pipe(
              map(task => {
                this._store.dispatch(new CreateTaskForSalesSuccess(task));
              }),
              catchError(err => {
                this._toastr.error('Что-то пошло не так', '', {
                  timeOut: 3500,
                });
                this._store.dispatch(new CreateTaskForSalesFailure(err.error));
                return err;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  updateTaskDeadLine$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<UpdateTaskDeadLineRequest>(
          ESalesChangesActions.UpdateTaskDeadLineRequest
        ),
        switchMap(action => {
          return this._salesChangesService
            .updateTaskDeadline(action.data, action.task_id)
            .pipe(
              map(() => {
                this._store.dispatch(new UpdateTaskDeadLineSuccess());
                this._toastr.success('Дедлайн успешно изменен', '', {
                  timeOut: 3500,
                });
              }),
              catchError(err => {
                this._toastr.error('Что-то пошло не так', '', {
                  timeOut: 3500,
                });
                this._store.dispatch(new UpdateTaskDeadLineFailure(err.error));
                return err;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  editEnrolleeData$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<EditEnrolleeRequest>(ESalesChangesActions.EditEnrolleeRequest),
        switchMap(action => {
          return this._salesChangesService
            .editEnrolleeData(action.id, action.data)
            .pipe(
              map(() => {
                this._store.dispatch(new EditEnrolleeSuccess());
                this._toastr.success('Заявка успешно изменена', '', {
                  timeOut: 3500,
                });
              }),
              catchError(err => {
                this._toastr.error('Что-то пошло не так', '', {
                  timeOut: 3500,
                });
                this._store.dispatch(new EditEnrolleeFailure(err.error));
                return err;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  updateEnrollDataInPresentation$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<ChangeEnrollDataInPresentationRequest>(
          ESalesChangesActions.ChangeEnrollDataInPresentationRequest
        ),
        switchMap(action => {
          return this._salesChangesService
            .updateEnrollPresentation(
              action.enroll_id,
              action.data,
              action.token
            )
            .pipe(
              map(() => {
                this._store.dispatch(
                  new ChangeEnrollDataInPresentationSuccess()
                );
                this._toastr.success('Данные успешно изменены', '', {
                  timeOut: 3500,
                });
              }),
              catchError(err => {
                this._toastr.error('Что-то пошло не так', '', {
                  timeOut: 3500,
                });
                this._store.dispatch(
                  new ChangeEnrollDataInPresentationFailure(err.error)
                );
                return err;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  updateTask$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<UpdateTaskForSalesRequest>(
          ESalesChangesActions.UpdateTaskForSalesRequest
        ),
        switchMap(action => {
          return this._salesChangesService
            .updateTask(action.task_id, action.data)
            .pipe(
              map(() => {
                this._store.dispatch(new UpdateTaskForSalesSuccess());
              }),
              catchError(err => {
                if (err.error && err.error.detail) {
                  this._toastr.error(err.error.detail, '', {
                    timeOut: 3500,
                  });
                } else {
                  this._toastr.error('Что-то пошло не так', '', {
                    timeOut: 3500,
                  });
                }

                this._store.dispatch(new UpdateTaskForSalesFailure(err.error));
                return err;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  addFileToTask$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<AddFileToTaskRequest>(ESalesChangesActions.AddFileToTaskRequest),
        switchMap(action => {
          return this._salesChangesService.addFileToTask(action.data).pipe(
            map(() => {
              this._store.dispatch(new AddFileToTaskSuccess());
            }),
            catchError(err => {
              if (err.error && err.error.file) {
                this._toastr.error(err.error.file, '', {
                  timeOut: 3500,
                });
              } else {
                this._toastr.error('Что-то пошло не так', '', {
                  timeOut: 3500,
                });
              }

              this._store.dispatch(new AddFileToTaskFailure(err.error));
              return err;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  deleteFileFromTask$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<DeleteFileFromTaskRequest>(
          ESalesChangesActions.DeleteFileFromTaskRequest
        ),
        switchMap(action => {
          return this._salesChangesService.deleteFileFromTask(action.id).pipe(
            map(() => {
              this._store.dispatch(new DeleteFileFromTaskSuccess());
            }),
            catchError(err => {
              this._toastr.error('Что-то пошло не так', '', {
                timeOut: 3500,
              });
              this._store.dispatch(new DeleteFileFromTaskFailure(err.error));
              return err;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  addContractCredentials$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<AddContractCredentialsRequest>(
          ESalesChangesActions.AddContractCredentialsRequest
        ),
        switchMap(action => {
          return this._salesChangesService
            .addContractCredentials(action.data)
            .pipe(
              map(() => {
                this._toastr.success(
                  'Контрактное лицо, было успешно создано',
                  '',
                  {
                    timeOut: 3500,
                  }
                );
                this._store.dispatch(new AddContractCredentialsSuccess());
              }),
              catchError(err => {
                this._toastr.error('Что-то пошло не так', '', {
                  timeOut: 3500,
                });
                this._store.dispatch(
                  new AddContractCredentialsFailure(err.error)
                );
                return err;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  editContractCredentials$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<EditContractCredentialsRequest>(
          ESalesChangesActions.EditContractCredentialsRequest
        ),
        switchMap(action => {
          return this._salesChangesService
            .editContractCredentials(action.data, action.id)
            .pipe(
              map(() => {
                this._store.dispatch(new EditContractCredentialsSuccess());
              }),
              catchError(err => {
                this._toastr.error('Что-то пошло не так', '', {
                  timeOut: 3500,
                });
                this._store.dispatch(
                  new EditContractCredentialsFailure(err.error)
                );
                return err;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  changeTaskExecuter$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<ChangeTaskExecuterRequest>(
          ESalesChangesActions.ChangeTaskExecuterRequest
        ),
        switchMap(action => {
          return this._salesChangesService.changeTaskExecuter(action.data).pipe(
            map(() => {
              this._store.dispatch(new ChangeTaskExecuterSuccess());
              this._toastr.success('Задача была успешно переназначена', '', {
                timeOut: 3500,
              });
            }),
            catchError(err => {
              this._toastr.error('Что-то пошло не так', '', {
                timeOut: 3500,
              });
              this._store.dispatch(new ChangeTaskExecuterFailure(err.error));
              return err;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  changeTaskStatus$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<ChangeSalesTaskStatusRequest>(
          ESalesChangesActions.ChangeSalesTaskStatusRequest
        ),
        switchMap(action => {
          return this._salesChangesService
            .changeTaskStatus(action.data, action.task_id)
            .pipe(
              map(() => {
                this._store.dispatch(new ChangeSalesTaskStatusSuccess());
                this._toastr.success('Статус задачи был успешно изменен', '', {
                  timeOut: 3500,
                });
              }),
              catchError(err => {
                this._toastr.error('Что-то пошло не так', '', {
                  timeOut: 3500,
                });
                this._store.dispatch(
                  new ChangeSalesTaskStatusFailure(err.error)
                );
                return err;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  indicateLeadToCourseAndGroup$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<IndicateLeadToCourseAndGroupRequest>(
          ESalesChangesActions.IndicateLeadToCourseAndGroupRequest
        ),
        switchMap(action => {
          return this._salesChangesService
            .indicateLeadToCourseAndGroup(action.data, action.lead_id)
            .pipe(
              map(() => {
                this._store.dispatch(new IndicateLeadToCourseAndGroupSuccess());
                this._toastr.success('Курс и группа успешно заданы', '', {
                  timeOut: 3500,
                });
              }),
              catchError(err => {
                this._toastr.error('Что-то пошло не так', '', {
                  timeOut: 3500,
                });
                this._store.dispatch(
                  new IndicateLeadToCourseAndGroupFailure(err.error)
                );
                return err;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  generateContractToLead$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GenerateContractToLeadRequest>(
          ESalesChangesActions.GenerateContractToLeadRequest
        ),
        switchMap(action => {
          return this._salesChangesService
            .generateContractToLead(action.lead_id, action.data)
            .pipe(
              map(() => {
                this._store.dispatch(new GenerateContractToLeadSuccess());
                this._toastr.success('Контракт успешно сгенерирован', '', {
                  timeOut: 3500,
                });
              }),
              catchError(err => {
                // this._toastr.error('Что-то пошло не так', '', {
                //     timeOut: 3500,
                // });
                this._store.dispatch(
                  new GenerateContractToLeadFailure(err.error)
                );
                return err;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  addLeadDocuments$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<AddLeadDocumentsRequest>(
          ESalesChangesActions.AddLeadDocumentsRequest
        ),
        switchMap(action => {
          return this._salesChangesService.addLeadDocument(action.data).pipe(
            map(() => {
              this._store.dispatch(new AddLeadDocumentsSuccess());
              this._toastr.success('Документ успешно добавлен', '', {
                timeOut: 3500,
              });
            }),
            catchError(err => {
              this._toastr.error('Что-то пошло не так', '', {
                timeOut: 3500,
              });
              this._store.dispatch(new AddLeadDocumentsFailure(err.error));
              return err;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  deleteLeadDocuments$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<DeleteLeadDocumentsRequest>(
          ESalesChangesActions.DeleteLeadDocumentsRequest
        ),
        switchMap(action => {
          return this._salesChangesService
            .deleteLeadDocument(action.document_id)
            .pipe(
              map(() => {
                this._store.dispatch(new AddLeadDocumentsSuccess());
                this._toastr.success('Документ успешно удален', '', {
                  timeOut: 3500,
                });
              }),
              catchError(err => {
                this._toastr.error('Что-то пошло не так', '', {
                  timeOut: 3500,
                });
                this._store.dispatch(new DeleteLeadDocumentsFailure(err.error));
                return err;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  createDealToLead$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<CreateDealToLeadRequest>(
          ESalesChangesActions.CreateDealToLeadRequest
        ),
        switchMap(action => {
          return this._salesChangesService.createDealToLead(action.data).pipe(
            map(() => {
              this._store.dispatch(new CreateDealToLeadSuccess());
              this._toastr.success('Сделка успешно создана', '', {
                timeOut: 3500,
              });
            }),
            catchError(err => {
              if (err.error.detail) {
                this._toastr.error(err.error.detail, '', {
                  timeOut: 3500,
                });
              } else {
                this._toastr.error('Что-то пошло не так', '', {
                  timeOut: 3500,
                });
              }

              this._store.dispatch(new CreateDealToLeadFailure(err.error));
              return err;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  closeDealToLead$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<CloseDealToLeadRequest>(
          ESalesChangesActions.CloseDealToLeadRequest
        ),
        switchMap(action => {
          return this._salesChangesService.closeDealToLead(action.deals).pipe(
            map((data: { detail: string[] }) => {
              this._store.dispatch(new CloseDealToLeadSuccess(data.detail));
              this._toastr.success(
                `${
                  action.deals.deals.length > 1
                    ? 'Сделки успешно закрыты'
                    : 'Сделка успешно закрыта'
                }`,
                '',
                {
                  timeOut: 3500,
                }
              );
            }),
            catchError(err => {
              this._toastr.error('Что-то пошло не так', '', {
                timeOut: 3500,
              });
              this._store.dispatch(new CloseDealToLeadFailure(err.error));
              return err;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  editDeal$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<EditDealRequest>(ESalesChangesActions.EditDealRequest),
        switchMap(action => {
          return this._salesChangesService
            .editDeal(action.deal, action.deal_id)
            .pipe(
              map(() => {
                this._store.dispatch(new EditDealSuccess());
                this._toastr.success(`Сделка успешно отредактирована`, '', {
                  timeOut: 3500,
                });
              }),
              catchError(err => {
                if (err.error.detail) {
                  this._toastr.error(err.error.detail, '', {
                    timeOut: 3500,
                  });
                } else {
                  this._toastr.error('Что-то пошло не так', '', {
                    timeOut: 3500,
                  });
                }
                this._store.dispatch(new EditDealFailure(err.error));
                return err;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  addPaymentNote$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<AddPaymentNoteRequest>(
          ESalesChangesActions.AddPaymentNoteRequest
        ),
        switchMap(action => {
          return this._salesChangesService.addPaymentNote(action.data).pipe(
            map(() => {
              this._store.dispatch(new AddPaymentNoteSuccess());
              this._toastr.success(`Оплата успешно внесена`, '', {
                timeOut: 3500,
              });
            }),
            catchError(err => {
              if (err.error?.non_field_errors) {
                this._toastr.error(err.error?.non_field_errors, '', {
                  timeOut: 3500,
                });
              } else {
                this._toastr.error('Что-то пошло не так', '', {
                  timeOut: 3500,
                });
              }
              this._store.dispatch(new AddPaymentNoteFailure(err.error));
              return err;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  addNewDiscount$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<AddDiscountRequest>(ESalesChangesActions.AddDiscountRequest),
        switchMap(action => {
          return this._salesChangesService.addNewDiscount(action.data).pipe(
            map(() => {
              this._store.dispatch(new AddDiscountSuccess());
              this._toastr.success('Cкидка успешно создана', '', {
                timeOut: 3500,
              });
            }),
            catchError(err => {
              if (err.error?.non_field_errors) {
                this._toastr.error(err.error?.non_field_errors, '', {
                  timeOut: 3500,
                });
              } else if (err.error?.detail) {
                this._toastr.error(err.error?.detail, '', {
                  timeOut: 3500,
                });
              } else {
                this._toastr.error('Что-то пошло не так', '', {
                  timeOut: 3500,
                });
              }
              this._store.dispatch(new AddDiscountFailure(err.error));
              return err;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  editDiscount$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<EditDiscountRequest>(ESalesChangesActions.EditDiscountRequest),
        switchMap(action => {
          return this._salesChangesService
            .editDiscount(action.data, action.id)
            .pipe(
              map(() => {
                this._store.dispatch(new EditDiscountSuccess());
                this._toastr.success('Cкидка успешно отредактирована', '', {
                  timeOut: 3500,
                });
              }),
              catchError(err => {
                if (err.error?.non_field_errors) {
                  this._toastr.error(err.error?.non_field_errors, '', {
                    timeOut: 3500,
                  });
                } else {
                  this._toastr.error('Что-то пошло не так', '', {
                    timeOut: 3500,
                  });
                }
                this._store.dispatch(new EditDiscountFailure(err.error));
                return err;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  addDiscountForLead$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<AddDiscountForLeadRequest>(
          ESalesChangesActions.AddDiscountForLeadRequest
        ),
        switchMap(action => {
          return this._salesChangesService
            .addDiscountForLead(action.data, action.lead_id)
            .pipe(
              map(() => {
                this._store.dispatch(new AddDiscountForLeadSuccess());
                this._toastr.success(
                  'Скидка(и) лиду успешно добавлена(ы)',
                  '',
                  {
                    timeOut: 3500,
                  }
                );
              }),
              catchError(err => {
                if (err.error?.detail) {
                  this._toastr.error(err.error?.detail, '', {
                    timeOut: 3500,
                  });
                } else {
                  this._toastr.error('Что-то пошло не так', '', {
                    timeOut: 3500,
                  });
                }
                this._store.dispatch(new AddDiscountForLeadFailure(err.error));
                return err;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  deleteLeadDiscount$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<DeleteDiscountLeadRequest>(
          ESalesChangesActions.DeleteDiscountLeadRequest
        ),
        switchMap(action => {
          return this._salesChangesService
            .deleteDiscountForLead(action.discount_id)
            .pipe(
              map(() => {
                this._toastr.success('Скидка лида успешно удалена', '', {
                  timeOut: 3500,
                });
              }),
              catchError(err => {
                this._toastr.error(
                  `${
                    err?.error?.detail
                      ? err?.error?.detail
                      : 'При удалении скидки возникла ошибка'
                  }`,
                  'Что-то пошло не так',
                  {
                    timeOut: 3500,
                  }
                );
                this._store.dispatch(new DeleteDiscountLeadRequest(err.error));
                return err;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  deleteStudentDiscount$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<DeleteDiscountStudentRequest>(
          ESalesChangesActions.DeleteDiscountStudentRequest
        ),
        switchMap(action => {
          return this._salesChangesService
            .deleteDiscountForStudent(action.discount_id)
            .pipe(
              map(() => {
                this._toastr.success('Скидка студента успешно удалена', '', {
                  timeOut: 3500,
                });
              }),
              catchError(err => {
                this._toastr.error(
                  `${
                    err?.error?.detail
                      ? err?.error?.detail
                      : 'При удалении скидки возникла ошибка'
                  }`,
                  'Что-то пошло не так',
                  {
                    timeOut: 3500,
                  }
                );
                this._store.dispatch(
                  new DeleteDiscountStudentRequest(err.error)
                );
                return err;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  addDiscountForStudent$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<AddDiscountForStudentRequest>(
          ESalesChangesActions.AddDiscountForStudentRequest
        ),
        switchMap(action => {
          return this._salesChangesService
            .addDiscountForStudent(action.data)
            .pipe(
              map(() => {
                this._store.dispatch(new AddDiscountForStudentSuccess());
                this._toastr.success(
                  'Скидка(и) студенту успешно добавлена(ы)',
                  '',
                  {
                    timeOut: 3500,
                  }
                );
              }),
              catchError(err => {
                if (err.error?.detail) {
                  this._toastr.error(err.error?.detail, '', {
                    timeOut: 3500,
                  });
                } else {
                  this._toastr.error('Что-то пошло не так', '', {
                    timeOut: 3500,
                  });
                }
                this._store.dispatch(
                  new AddDiscountForStudentFailure(err.error)
                );
                return err;
              })
            );
        })
      );
    },
    { dispatch: false }
  );
}
